import { FormControl } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Component, Inject, Input, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { InventoryService } from "src/app/services/inventory.service";
import { FBATypeEnum } from "src/app/core/Constants";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { Observable, Subject, merge, of } from "rxjs";
import { map, startWith, switchMap, takeUntil} from "rxjs/operators";
import { VendorTypeAhead } from "src/app/models/inventory.model";
import { RestockTag } from "src/app/models/purchasing.model";
import { SettingsService } from "src/app/services/settings.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "src/app/services/auth.service";
import { LoginModel } from "src/app/models/login.model";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { ShipmentVelocityComponent } from "../shipment-velocity/shipment-velocity.component";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";

@Component({
  selector: "app-quick-filters",
  templateUrl: "./quick-filters.component.html",
  styleUrls: ["./quick-filters.component.scss"],
})
export class QuickFiltersComponent implements OnInit,OnDestroy {
  @Input() shipmentType;
  showLoader:boolean=false;
  FBATypeEnum = FBATypeEnum;
  form: FormGroup = new FormGroup({});
  filteredOptions$: Observable<VendorTypeAhead[]>;
  RestockTag = RestockTag;
  warehouses: any[];
  page:string;
  settingsForm: FormGroup;
  userInfo:LoginModel;
  isShipyardOnly:boolean=false;
  filterOptionsWarehouse: Observable<any> = new Observable();
  allTags: any;
  private destroy$ = new Subject<void>();
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ShipmentVelocityComponent>,
    public gridActionsService: GridActionsService,
    private inventoryService: InventoryService,
    private settingsService:SettingsService,
    private snackBar:MatSnackBar,
    private authService:AuthService,
    private shipyardService: ShipyardService
  ) {}

  ngOnInit(): void {
    if (this.data.filterType === "purchasing" || this.data.filterType === "purchase-by-sku") {
      this.form.addControl("vendor", new FormControl({name: this.data.currentValue} || ""));
      this.form.addControl('tag',new FormControl(this.data.tag || 'all'));
      this.form.addControl("status", new FormControl(this.data.status));
      this.form.get("status").setValue(this.data.status);
      this.filteredOptions$ = this.form
        .get("vendor")
        .valueChanges.pipe(
          switchMap((value) => this.inventoryService.typeaheadVendor(value))
        );
        this.getTags();
    }else{
      this.authService.userInfo$.pipe(takeUntil(this.destroy$)).pipe(takeUntil(this.destroy$)).subscribe((res) => (this.userInfo = res));     
      this.form.addControl("replenishnostock", new FormControl());
      this.form.addControl("replenishwarehouse", new FormControl());
      this.form.addControl("queuedSku", new FormControl());
      const payload = this.getSettingsKeys();
      this.settingsService.GetSettings(payload).pipe(takeUntil(this.destroy$)).subscribe((res: any[]) => {
        const replenishnostock = res.find(
          (x) => x.name === SettingsKeyMap["replenishnostock"]
        );
        const replenishwarehouse = res.find(
          (x) => x.name === SettingsKeyMap["replenishwarehouse"]
        );
        this.settingsService.GetAllWarehouses().pipe(takeUntil(this.destroy$)).subscribe((res: any[]) => {
          this.warehouses = res.filter((res) => res.isCarriesInventory);
          if(this.warehouses.length){
            let index =  this.warehouses.findIndex(x=> x.warehouseId == this.shipyardService.warehouseId);
            this.form.get("replenishwarehouse").setValue(index != -1 ? this.warehouses[index] : null);
          }
        });
        this.form.get("replenishnostock").setValue(replenishnostock ? !replenishnostock.isOn : true);

        this.form.get("queuedSku").setValue(this.data.filterInputValue ? this.data.filterInputValue : false);
        this.isShipyardOnly = (!this.userInfo.isPlanYard  && !this.userInfo.isPriceYard && !this.userInfo.isYardener && this.form.get("replenishnostock").value);
      })  
    }
  }

  getSettingsKeys(): string[] {
      return [
        "replenishnostock",
        'replenishwarehouse'
      ];
  }

  clearFilter(): void {
    this.form.reset();
    if (this.data.filterType === "purchasing" || this.data.filterType === "purchase-by-sku") {
      this.form.get("vendor").setValue("");
      this.form.get("status").setValue("");
      this.form.get("tag").setValue("all");
    }
    this.dialogRef.close(this.form.value);
  }

  save() {
    if(this.data.filterType === "purchasing" || this.data.filterType === "purchase-by-sku"){
      this.dialogRef.close(!this.form.pristine ? this.form.value : null);
    }else{
      this.showLoader = true;
      const form = this.form.getRawValue();
      const payload = [];
      Object.keys(form).forEach((key) => {
        if (form[key] !== undefined && key !== "queuedSku") {
          if(key == 'replenishwarehouse'){
            payload.push({
              name: SettingsKeyMap[key],
              isOn: form[key] ? true : false,
              str1:form[key]?.id
            });
          } 
          else if (SettingsKeyMap[key] == 'replenishnostock'){
            payload.push({
              name: SettingsKeyMap[key],
              isOn: form[key] ? false : true,
            });
          }
          else{
              payload.push({
                name: SettingsKeyMap[key],
                isOn: form[key] ? true : false,
              });
          }
        }
      });
      this.settingsService.SaveSettings(payload).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res:any) => {
          if (res) {
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'Settings saved successfully',
                  action: 'Dismiss',
                  type: 'success',
                },
              }
            );
            this.dialogRef.close(!this.form.pristine ? this.form.value : null);
          }
          this.showLoader = false;
        },
       error: (err) => {
        this.showLoader = false
       }
     });
    }
  }

  displayWith(value: any) {
    if (value) {
      return value.name;
    }
  }
  
  searchWarehouse() {
    this.filterOptionsWarehouse = merge(
      this.form.get("replenishwarehouse").valueChanges
    ).pipe(
      startWith(""),
      switchMap(() => of(this.warehouses)),
      map((warehouses: any[]) => {
        if (!this.form.get('replenishwarehouse').value) {
          return warehouses;
        } else {
          return warehouses.filter((warehouse) => {
            return (warehouse.name?.toLowerCase().includes(this.form.get('replenishwarehouse')?.value?.toString().toLowerCase()) ||
            warehouse.city?.toLowerCase().includes(this.form.get('replenishwarehouse')?.value?.toString().toLowerCase()) ||
            warehouse.state?.toLowerCase().includes(this.form.get('replenishwarehouse')?.value?.toString().toLowerCase())
            );
          });
        }
      })
    );
  }

  displayWithWarehouse(value: any) {
    if (value) {
      return value.name + '(' + (value.city ? (value.city + ',') : '') + value.state + ')';
    }
  }

  getTags() {
    this.inventoryService.GetTags().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data) {
        this.allTags = data;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}

const SettingsKeyMap = {
  'replenishnostock': 'replenishnostock',
  'replenishwarehouse': 'replenishwarehouse'
}
